module.exports = __webpack_public_path__ + "media/educator_advisory_board/mark_kantro-e83ea9e5.png";